module.exports = __webpack_public_path__ + "static/media/researcher.c6346c8a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/auth/ui/screens/forgot-password/researcher.svg
// module id = 841
// module chunks = 0